/* eslint no-unused-vars: "off" */
import Vue from "vue";
import np from "nprogress";
import APIs from "@lib/apiz";
import request from "mini-ajax";
import fetch from "@lib/request-promise";
import { getCookie, getJWT, unsetCookie } from "@lib/util";
import HttpClient from "@lib/http-client";
import "nprogress/nprogress.css";
import App from "./App";
import { proxyConfig, proxy_ } from "./proxy";
import apiConf from "./apis";
import router from "./router";
import vuePreload from "vue-preload-page";
import "@lib/flexible";
// 预加载页面js的小工具
vuePreload(router, Vue);
import wechatConfig from "@lib/wechat-config-fn";
import Share from "wechat-share-manager";
import "@lib/polyfill";

// Sentry
// async function installErrorTracking (dsn, release, environment) {
//   const Raven = await import('raven-js')
//   const RavenVue = await import('raven-js/plugins/vue')
//   Raven
//     .config(dsn, {
//       release,
//       environment,
//       whitelistUrls: [/pandateacher\.com/]
//     })
//     .addPlugin(RavenVue, Vue)
//     .install()

//   const token = getCookie('token')
//   const payload = JSON.parse(atob(token.split('.')[1]))
//   Raven.setUserContext({
//     token: getCookie('token'),
//     id: payload.id,
//     oid: payload.oid
//   })

//   window.onunhandledrejection = function (evt) {
//     Raven.captureException(evt.reason)
//   }
// }

if (process.env.NODE_ENV === "production") {
  setTimeout(() => {
    // installErrorTracking(process.env.SENTRY_DSN, process.env.VERSION, process.env.NODE_ENV)
    installCnzz();
  }, 1000);
}

function installCnzz() {
  let src = "https://s13.cnzz.com/z_stat.php?id=1262709816&web_id=1262709816";
  let script = document.createElement("script");
  script.async = true;
  script.src = src;
  document.querySelector("head").appendChild(script);
}

// AlloyLever
async function installAlloyLever() {
  const AlloyLever = await import("alloylever");
  AlloyLever.config({
    cdn: "https://unpkg.com/alloylever@1.0.1/alloy-lever.js",
    reportUrl: "",
    entry: "#btn"
  });
}

if (location.search.search(/vconsole/) !== -1) {
  installAlloyLever();
}

/**
 * fix ios tap bug
 */
document.addEventListener("touchstart", () => {});

Vue.config.productionTip = false;

const client = new HttpClient(
  xhr => {
    const token = getCookie("token");
    xhr.setRequestHeader("Authorization", `Bearer ${token}`);
  },
  (xhr, status) => {
    if (status === 401) {
      const authPath = `https://${window.ENV}.pandateacher.com/common/wechat-uauth`;
      const authPublich = `${window.APP_POSITION}` || "pyclass";
      const authReferer = btoa(window.location.href);
      window.location.href = `${authPath}?appName=${authPublich}&referer=${authReferer}`;
    } else if (status === 403) {
    } else if (status >= 500 || status === 404) {
      try {
        const body = JSON.parse(xhr.responseText);
        alert(`服务器正在升级中...\n${body.message}`);
      } catch (err) {
        alert("服务器正在升级中...");
      }
    }
  }
);

let apis = new APIs(apiConf, client);
// try {//不确定兼容情况
//   apis = new Proxy(apis, proxyConfig);
// } catch (error) {//兼容代码
//   apis = proxy_(apis);
// }

window.apis = apis;
window.np = np;
window.router = router;
window.unsetCookie = unsetCookie;
window.share = new Share(Vue, router);

wechatConfig([
  "showMenuItems",
  "hideMenuItems",
  "onMenuShareTimeline",
  "onMenuShareAppMessage",
  "downloadVoice",
  "playVoice",
  "stopVoice",
  "onVoicePlayEnd",
  "startRecord",
  "stopRecord",
  "onVoiceRecordEnd",
  "uploadVoice"
]);
// .then(() => {
//   const position = window.APP_POSITION || "pyclass";
//   return window.apis.commonShare({ app_name: position });
// })
// .then(({ data: { share: params } }) => {
//   return share.init(params);
// });

Vue.prototype.$request = request;
Vue.prototype.$fetch = fetch;
Vue.prototype.$apis = apis;

/* eslint-disable no-new */
new Vue({
  el: "#app",
  router,
  render: h => h(App)
});



// WEBPACK FOOTER //
// ./src/main.js